import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  CircularProgress,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import ModernButton from '../common/ModernButton';

const FormPageLayout = ({
  title,
  subtitle,
  icon,
  loading,
  children,
  onBack,
  backPath,
  backLabel = 'Back',
  breadcrumbs,
  actions,
  maxWidth = 'lg',
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth, mx: 'auto' }}>
      {/* Breadcrumbs */}
      {breadcrumbs && (
        <Breadcrumbs sx={{ mb: 2 }}>
          {breadcrumbs.map((crumb, index) => (
            <Link
              key={index}
              component={crumb.path ? RouterLink : 'span'}
              to={crumb.path}
              color={index === breadcrumbs.length - 1 ? 'text.primary' : 'inherit'}
              underline={crumb.path ? 'hover' : 'none'}
              sx={{ fontWeight: index === breadcrumbs.length - 1 ? 600 : 400 }}
            >
              {crumb.label}
            </Link>
          ))}
        </Breadcrumbs>
      )}

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {icon && (
              <Avatar sx={{ backgroundColor: 'primary.main', width: 48, height: 48, mr: 2 }}>
                {icon}
              </Avatar>
            )}
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            {(onBack || backPath) && (
              <ModernButton
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={onBack}
                component={backPath && !onBack ? RouterLink : undefined}
                to={backPath}
              >
                {backLabel}
              </ModernButton>
            )}
            {actions}
          </Box>
        </Box>
      </Box>

      {/* Content */}
      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ p: 4 }}>
          {children}
        </CardContent>
      </Card>
    </Box>
  );
};

export default FormPageLayout;
